/**
 * ClientsApiService — API-first client (account) operations.
 */

import { ApiClient } from '../ApiClient.js';

export class ClientsApiService {
    static async list({ page = 1, per_page = 50, search = null } = {}) {
        return ApiClient.get('/api/v1/clients', { page, per_page, search });
    }

    static async getById(clientId) {
        // OpenAPI says /api/v1/clients/{client_id}.
        // Your pasted snippet doesn't show it, but docs/BACKEND_API_PLAN says it exists.
        return ApiClient.get(`/api/v1/clients/${encodeURIComponent(clientId)}`);
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/clients', payload);
    }

    static async update(clientId, payload) {
        return ApiClient.put(`/api/v1/clients/${encodeURIComponent(clientId)}`, payload);
    }

    static async softDelete(clientId) {
        return ApiClient.delete(`/api/v1/clients/${encodeURIComponent(clientId)}`);
    }

    static async restore(clientId) {
        return ApiClient.post(`/api/v1/clients/${encodeURIComponent(clientId)}/restore`, {});
    }

    static async checkName(name) {
        return ApiClient.get('/api/v1/clients/check-name', { name });
    }
}
